import back from '../shared/back.vue';
import buttonRadar from '../shared/button-radar.vue';


export default  {

  name: 'our-technology',

  components:{

    back,
    buttonRadar

  },

  data() {
    return {

      videoIsFinished: false,
      from: null,
      autoplay: localStorage.getItem('play'),

    }
  },

  methods:{

    // Video doesn't autoplay on Mobile devices, so lets fake a tap
    play(){

      let video = document.getElementById("video");

      setTimeout(function () {

        video.play();

      }, 500);

    }

  },


  mounted(){

    let vm = this;
    let app = document.getElementById("app");
    let video = document.getElementById("video");
    let player = document.getElementById("player");


    let p =  localStorage.getItem('play');

    if(p == 'false'){

      this.videoIsFinished = true;
      video.currentTime = 3;
      video.pause();

      video.style.zIndex = -1;
      video.style.opacity = 0;

    }else{

      player.click();

    }

    video.addEventListener('ended', function () {

      // Set the APP background image to match the first frame of the videos, so we have a nice transition
      app.style.backgroundImage = "url('/static/media/images/our-technology-background.jpg')";

      video.style.zIndex = -1;
      video.style.opacity = 0;

      vm.videoIsFinished = true;

    });


  },

  destroyed(){

    let video = document.getElementById("video");
    video.currentTime = 0;
    video.pause();

  }


}




// WEBPACK FOOTER //
// ./src/components/our-technology/our-technology.component.js